//MODAL DE TERMOS DE USO DA APLICAÇÃO
import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./Terms.css";

const Terms = ({ show, handleAccept }) => {
  const [accepted, setAccepted] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const termsAccepted = localStorage.getItem("termsAccepted");
    if (!termsAccepted) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [show]);

  const handleConfirm = () => {
    localStorage.setItem("termsAccepted", "true");
    setShowModal(false);
    handleAccept();
  };

  return (
    <Modal
      show={showModal}
      backdrop="static"
      keyboard={false}
      centered
      className="custom-modal"
    >
      <Modal.Body>
        <div className="terms-container">
          <h5 className="text-center fw-bold">
            Para você acessar o sistema é necessário estar ciente e de acordo
            com os requisitos e obrigações do Programa Meritocracia Sindical
            2026, incluindo:
          </h5>

          <div className="terms-list">
            <div className="terms-item">
              ✅ Cumprimento dos critérios estabelecidos no regulamento do
              programa.
            </div>
            <div className="terms-item">
              ✅ Envio da documentação obrigatória dentro dos prazos
              estipulados.
            </div>
            <div className="terms-item">
              ✅ Responsabilidade sobre a veracidade das informações fornecidas.
            </div>
            <div className="terms-item">
              ✅ Concordância com eventuais sanções em caso de descumprimento
              das regras.
            </div>
          </div>

          <div className="terms-box">
            <div className="terms-text">
              <p className="mb-0 fw-bold">
                Para mais detalhes consulte o regulamento
              </p>
              <a
                href="https://fiemg.sharepoint.com/:b:/r/sites/DS-DesenvolvimentoSindical/Documentos%20Compartilhados/01.%20PROJETOS/03.%20MERITOCRACIA%20SINDICAL/REGULAMENTO_MERITOCRACIA_2026%20VF.pdf?csf=1&web=1&e=fkcggR"
                target="_blank"
                rel="noopener noreferrer"
                className="regulation-link"
              >
                Regulamento Meritocracia 2026
              </a>
            </div>
          </div>

          <div className="terms-checkbox">
            <Form.Group controlId="formBasicCheckbox">
              <Form.Check
                type="checkbox"
                label="Li e concordo com os termos do Programa Meritocracia Sindical 2026."
                onChange={(e) => setAccepted(e.target.checked)}
              />
            </Form.Group>
          </div>

          <div className="text-center mt-3">
            <Button
              variant="primary"
              disabled={!accepted}
              onClick={handleConfirm}
              className="access-button"
            >
              ACESSAR SISTEMA
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Terms;
